import { makeStyles, Text } from "@fluentui/react-components";
import IPageTwoColumnText from "../../../models/page/pageComponents/IPageTwoColumnText";
import { dolphinTokens } from "../../../utils/Theme";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "row",
        gap: "3rem",
        padding: "0 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
        "@media (max-width: 768px)": {
            flexDirection: "column",
            gap: "2rem",
        },
    },
    column: {
        flex: "1",
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
    },
    columnTitle: {
        fontWeight: "700",
        fontSize: "1.3rem",
        color: dolphinTokens.colorDarkBlue,
    },
    columnContent: {
        color: "#555555",
        fontSize: "1rem",
        lineHeight: "1.8",
        whiteSpace: "pre-wrap",
    },
});

export default function TwoColumnText(props: IPageTwoColumnText) {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <div className={styles.column}>
                {props.leftTitle && (
                    <Text block className={styles.columnTitle}>{props.leftTitle}</Text>
                )}
                <Text block className={styles.columnContent}>{props.leftContent}</Text>
            </div>
            <div className={styles.column}>
                {props.rightTitle && (
                    <Text block className={styles.columnTitle}>{props.rightTitle}</Text>
                )}
                <Text block className={styles.columnContent}>{props.rightContent}</Text>
            </div>
        </div>
    );
}
